/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PuroConfigCreateSchema } from '../models/PuroConfigCreateSchema';
import type { PuroConfigListSchema } from '../models/PuroConfigListSchema';
import type { PuroConfigUpdateSchema } from '../models/PuroConfigUpdateSchema';
import type { PuroInputDataSchema } from '../models/PuroInputDataSchema';
import type { PuroInputDataSubmitSchema } from '../models/PuroInputDataSubmitSchema';
import type { PuroSnapshotSchema } from '../models/PuroSnapshotSchema';
import type { PuroSnapshotTriggerSchema } from '../models/PuroSnapshotTriggerSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PuroApi {
    /**
     * List Puro Configs
     * List PURO configs for current company. Required permission: view_puro
     * @returns PuroConfigListSchema OK
     * @throws ApiError
     */
    public static insuranceListPuroConfigsGet(): CancelablePromise<Array<PuroConfigListSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/puro/',
        });
    }
    /**
     * Create Puro Config
     * Create PURO config. Required permission: manage_puro
     * @returns PuroConfigListSchema Created
     * @throws ApiError
     */
    public static insuranceCreatePuroConfigPost({
        requestBody,
    }: {
        requestBody: PuroConfigCreateSchema,
    }): CancelablePromise<PuroConfigListSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/puro/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Update Puro Config
     * Update PURO config. Required permission: manage_puro
     * @returns PuroConfigListSchema OK
     * @throws ApiError
     */
    public static insuranceUpdatePuroConfigPatch({
        configId,
        requestBody,
    }: {
        configId: string,
        requestBody: PuroConfigUpdateSchema,
    }): CancelablePromise<PuroConfigListSchema> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/puro/{config_id}/',
            path: {
                'config_id': configId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete Puro Config
     * Delete PURO config. Required permission: manage_puro
     * @returns void
     * @throws ApiError
     */
    public static insuranceDeletePuroConfigDelete({
        configId,
    }: {
        configId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/puro/{config_id}/',
            path: {
                'config_id': configId,
            },
        });
    }
    /**
     * Get Puro Input Data
     * Get VZP settlement input data and computed results. Required permission: view_puro
     * @returns PuroInputDataSchema OK
     * @throws ApiError
     */
    public static insuranceGetPuroInputDataGet({
        configId,
    }: {
        configId: string,
    }): CancelablePromise<PuroInputDataSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/puro/{config_id}/input-data/',
            path: {
                'config_id': configId,
            },
        });
    }
    /**
     * Submit Puro Input Data
     * Submit or update VZP settlement data and recompute results. Required permission: manage_puro
     * @returns PuroInputDataSchema OK
     * @throws ApiError
     */
    public static insuranceSubmitPuroInputDataPost({
        configId,
        requestBody,
    }: {
        configId: string,
        requestBody: PuroInputDataSubmitSchema,
    }): CancelablePromise<PuroInputDataSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/puro/{config_id}/input-data/',
            path: {
                'config_id': configId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * List Puro Snapshots
     * List monthly KBatch snapshots for graph and TTL monitoring. Required permission: view_puro
     * @returns PuroSnapshotSchema OK
     * @throws ApiError
     */
    public static insuranceListPuroSnapshotsGet({
        configId,
        year,
    }: {
        configId: string,
        year?: (number | null),
    }): CancelablePromise<Array<PuroSnapshotSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/puro/{config_id}/snapshots/',
            path: {
                'config_id': configId,
            },
            query: {
                'year': year,
            },
        });
    }
    /**
     * Trigger Puro Snapshot
     * Manually trigger snapshot computation for a month. Required permission: manage_puro
     * @returns PuroSnapshotSchema OK
     * @throws ApiError
     */
    public static insuranceTriggerPuroSnapshotPost({
        configId,
        requestBody,
    }: {
        configId: string,
        requestBody: PuroSnapshotTriggerSchema,
    }): CancelablePromise<PuroSnapshotSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/puro/{config_id}/snapshots/trigger/',
            path: {
                'config_id': configId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
